import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useOrganizationReportUIContext } from "../../OrganizationReportUIContext";
import { initialFilter } from "../../OrganizationReportUIHelpers";
import AsyncSelect from "react-select/async";
import { genOptionLoaderParams } from "../../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../../_redux/organization/organizationCrud";
import { Select } from "../../../../../../../_metronic/_partials/controls";
import { generateYearsBetween } from "../../../../../../config/helper";

const prepareFilter = (queryParams, values) => {
  const { year, month, organization_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.organization_uuid = organization_uuid ?? "";
  filter.year = year ?? "";
  filter.month = month ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const OrganizationReportFilter = ({ listLoading }) => {
  // OrganizationReport UI Context
  const organizationReportUIContext = useOrganizationReportUIContext();
  const organizationReportUIProps = useMemo(() => {
    return {
      setQueryParams: organizationReportUIContext.setQueryParams,
      queryParams: organizationReportUIContext.queryParams,
      filterType: organizationReportUIContext.filterType
    };
  }, [organizationReportUIContext]);

  const [defaultOptions, setDefaultOptions] = useState({
    organizations: []
  });

  useEffect(() => {
    findorganization({
      page1umber: 1,
      pageSize: 10,
      filter: {}
    }).then(res => {
      const { data } = res.data;
      const options = data.items.map(item => ({
        label: item.name,
        value: item.uuid
      }));
      setDefaultOptions(prev => ({
        ...prev,
        organizations: options
      }));
    });
  }, []);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      organizationReportUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, organizationReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      organizationReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const [currentTimeout, setCurrentTimeout] = useState(null);

  const currentYear = new Date().getFullYear();
  const years = generateYearsBetween(currentYear - 5, currentYear);
  const months = Array.from({ length: 12 }, (e, i) => {
    let data = {};
    data.label = new Date(null, i + 1, null).toLocaleDateString("id", {
      month: "long"
    });
    data.value = i + 1;

    return data;
  });

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            {/* <div className="col-lg-4">
              <label htmlFor="name">Organisasi</label>
              <AsyncSelect
                name="organization_uuid"
                defaultOptions={defaultOptions.organizations}
                loadOptions={genOptionLoaderParams(
                  inputValue =>
                    findorganization({
                      page1umber: 1,
                      pageSize: 50,
                      filter: { name: inputValue }
                    }),
                  ({ name, uuid }) => ({
                    label: name ?? "",
                    value: uuid ?? ""
                  }),
                  currentTimeout,
                  setCurrentTimeout
                )}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("organization_uuid", value);
                  } else {
                    setFieldValue("organization_uuid", "");
                  }
                }}
              />
            </div> */}
            <div className="col-lg-4">
              <label>
                <strong>Pilih Tahun</strong>
              </label>
              <Select
                name="year"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Select>
            </div>
            <div className="col-lg-4">
              <label>
                <strong>Pilih Bulan</strong>
              </label>
              <Select
                name="month"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>

                {months.map(month => (
                  <option key={month} value={month.value}>
                    {month.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
